export default {
    '1': 'Tersalah pesan produk',
    '2': 'Pesanan berulang',
    '3': 'Tidak dapat menerima',
    '4': 'Sebab lain',
    '充值金额不能小于1': 'Ralat format: jumlah tambah nilai tidak boleh kurang daripada 1 (dengan 2 titik perpuluhan)',
    '-连接已建立-': '-Sambungan diwujudkan-',
    ',才可提币': ', baru boleh mengeluarkan',
    '[code]值错误': 'Nilai [code] tidak sah',
    '[symbol]参数为空': 'Parameter [symbol] kosong',
    homeDownloadtips41: 'Aplikasi Peniaga',
    '不能为空': 'Tidak boleh kosong',
    '不在交易时段': 'Bukan waktu dagangan',
    '不在可提现时间内': 'Bukan dalam waktu pengeluaran',
    '参数错误': 'Ralat parameter',
    '参数异常，消息获取失败': 'Parameter tidak normal, gagal mendapatkan mesej',
    '操作成功': 'Operasi berjaya',
    '操作类型不能小于0': 'Jenis operasi tidak boleh kurang daripada 0',
    '操作类型不是整数': 'Jenis operasi bukan integer',
    '操作类型为空': 'Jenis operasi kosong',
    '产品不存在': 'Produk tidak wujud',
    '产品剩余数量不足': 'Baki kuantiti produk tidak mencukupi',
    '承兑商不存在': 'Pedagang tidak wujud',
    '程序错误': 'Ralat program',
    '持有币种不足': 'Pegangan mata wang tidak mencukupi',
    '充值价值不得大于最大限额': 'Nilai tambah nilai tidak boleh melebihi had maksimum',
    '充值价值不得小于最小限额': 'Nilai tambah nilai tidak boleh kurang daripada had minimum',
    '充值链错误': 'Ralat rangkaian tambah nilai',
    '充值数量不能小于等于0': 'Kuantiti tambah nilai tidak boleh kurang atau sama dengan 0',
    '存在不同杠杆的持仓单': 'Terdapat posisi dengan leveraj berbeza',
    '存在重复的角色名称': 'Terdapat nama peranan berulang',
    '大于最大采购数量': 'Melebihi kuantiti belian maksimum',
    '代理层级错误': 'Ralat peringkat ejen',
    '待付款的订单无法放行': 'Pesanan belum bayar tidak boleh dilepaskan',
    '当前地址格式错误': 'Format alamat semasa tidak sah',
    '当前订单不为待付款状态，无法取消': 'Pesanan bukan dalam status menunggu bayaran, tidak boleh dibatalkan',
    '当前还需交易': 'Masih perlu berdagang',
    '当日才可申购': 'Hanya boleh melanggan pada hari yang sama',
    '当日可提现次数不足': 'Bilangan pengeluaran hari ini tidak mencukupi',
    '登陆密码不符合设定': 'Kata laluan log masuk tidak memenuhi tetapan',
    '登陆密码长度不符合设定': 'Panjang kata laluan log masuk tidak memenuhi tetapan',
    '登录过期，请重新登录': 'Sesi tamat, sila log masuk semula',
    '登录密码必须6-12位': 'Kata laluan log masuk mesti 6-12 aksara',
    '登录密码不能为空': 'Kata laluan log masuk tidak boleh kosong',
    '登录失败': 'Log masuk gagal',
    '电话号码已绑定': 'Nombor telefon telah dipaut',
    '电话号码已绑定其他用户': 'Nombor telefon telah dipaut dengan pengguna lain',
    '订单不存在': 'Pesanan tidak wujud',
    '订单已取消': 'Pesanan dibatalkan',
    '订单已取消，无法放行': 'Pesanan dibatalkan, tidak boleh dilepaskan',
    '订单已完成，无法放行': 'Pesanan selesai, tidak boleh dilepaskan',
    '发现新版本，请升级到最新版本': 'Versi baharu ditemui, sila kemas kini ke versi terkini',
    '服务器错误': 'Ralat pelayan',
    '服务器错误(500)': 'Ralat pelayan (500)',
    '该产品未上架': 'Produk ini belum disenaraikan',
    '该产品已上市，无法购买': 'Produk ini telah disenaraikan, tidak boleh dibeli',
    '该订单已取消': 'Pesanan ini telah dibatalkan',
    '该广告剩余数量不足': 'Baki kuantiti iklan ini tidak mencukupi',
    '该基金尚未开放购买': 'Dana ini belum dibuka untuk pembelian',
    '该基金尚已封闭': 'Dana ini telah ditutup',
    '该邮箱已被订阅': 'E-mel ini telah dilanggan',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Ralat format: jumlah tambah nilai tidak boleh kurang daripada 1 (dengan 2 titik perpuluhan)',
    '跟单倍数输入错误': 'Input gandaan copy trade tidak sah',
    '跟单参数输入错误': 'Input parameter copy trade tidak sah',
    '更新提醒': 'Peringatan kemas kini',
    '工作地址不能为空': 'Alamat kerja tidak boleh kosong',
    '购买矿机时间不得低于托管订单剩余时间': 'Tempoh pembelian mesin perlombongan tidak boleh kurang daripada baki masa pesanan hosting',
    '广告不存在': 'Iklan tidak wujud',
    '广告已下架': 'Iklan telah ditarik',
    '基金剩余购买金额不足': 'Baki jumlah pembelian dana tidak mencukupi',
    '家庭地址不能为空': 'Alamat rumah tidak boleh kosong',
    '交易员不存在': 'Pedagang tidak wujud',
    '交易员不能跟随自己': 'Pedagang tidak boleh mengikut diri sendiri',
    '交易员跟随人数已满': 'Bilangan pengikut pedagang telah penuh',
    '交易员未开启带单': 'Pedagang belum mengaktifkan copy trade',
    '交易员无法跟随另一个交易员': 'Pedagang tidak boleh mengikut pedagang lain',
    '角色被用户关联，不可删除': 'Peranan dipaut dengan pengguna, tidak boleh dipadam',
    '角色不存在': 'Peranan tidak wujud',
    '金额不在购买区间': 'Jumlah bukan dalam julat pembelian',
    '金额错误': 'Ralat jumlah',
    '旧密码不能为空': 'Kata laluan lama tidak boleh kosong',
    '旧密码不正确': 'Kata laluan lama tidak betul',
    '可平仓合约张数不足': 'Bilangan kontrak yang boleh ditutup tidak mencukupi',
    '矿机不存在': 'Mesin perlombongan tidak wujud',
    '矿机未解锁，无法购买': 'Mesin perlombongan belum dibuka kunci, tidak boleh dibeli',
    '历史基金无法购买': 'Dana sejarah tidak boleh dibeli',
    '连续输入错误三次，请3分钟后再试': 'Salah input tiga kali berturut-turut, sila cuba lagi selepas 3 minit',
    '领取成功': 'Berjaya dituntut',
    '买入金额需要在区间内': 'Jumlah belian mesti dalam julat',
    '卖方无法取消该订单': 'Penjual tidak boleh membatalkan pesanan ini',
    '没有找到用户': 'Pengguna tidak ditemui',
    verificationCode: 'Kod pengesahan',
    pleaseEnterVerificationCode: 'Sila masukkan kod pengesahan',
    pleaseEnterUsername: 'Sila masukkan nama pengguna',
    username: 'Nama pengguna',
    getVerificationCode: 'Dapatkan kod',
    tryAgainLater: 'saat untuk cuba lagi',
    '密码必须6-12位': 'Kata laluan mesti 6-12 aksara',
    '密码不能为空': 'Kata laluan tidak boleh kosong',
    '密码不正确': 'Kata laluan tidak betul',
    '您当前可分配额度不足': 'Had yang boleh diagihkan tidak mencukupi',
    '您没有符合条件的收款方式': 'Anda tiada kaedah pembayaran yang layak',
    '您已存在订单': 'Anda sudah mempunyai pesanan',
    '您已购买过体验矿机,不得重复购买': 'Anda telah membeli mesin perlombongan percubaan, tidak boleh beli semula',
    '亲属地址不能为空': 'Alamat saudara tidak boleh kosong',
    '亲属电话不能为空': 'Telefon saudara tidak boleh kosong',
    '亲属关系不能为空': 'Hubungan saudara tidak boleh kosong',
    '亲属姓名不能为空': 'Nama saudara tidak boleh kosong',
    '请检查网络连接': 'Sila semak sambungan rangkaian',
    '请切换其他语言后查看': 'Sila tukar ke bahasa lain untuk melihat',
    '请上传图片': 'Sila muat naik gambar',
    '请稍后再试': 'Sila cuba lagi kemudian',
    '请稍后重试': 'Sila cuba lagi kemudian',
    '请输入充值币种': 'Sila masukkan mata wang tambah nilai',
    '请输入内容': 'Sila masukkan kandungan',
    '请输入搜索关键字': 'Sila masukkan kata kunci carian',
    '请输入正确的货币数量': 'Sila masukkan kuantiti mata wang yang betul',
    '请输入正确的金额': 'Sila masukkan jumlah yang betul',
    '请输入正确的数量': 'Sila masukkan kuantiti yang betul',
    '请输入正确的质押金额': 'Sila masukkan jumlah pertaruhan yang betul',
    '请输入正确的质押天数': 'Sila masukkan bilangan hari pertaruhan yang betul',
    '请填写正确的电话号码': 'Sila isi nombor telefon yang betul',
    '请填写正确的验证码': 'Sila isi kod pengesahan yang betul',
    '请填写正确的邮箱地址': 'Sila isi alamat e-mel yang betul',
    '请先绑定谷歌验证器': 'Sila paut Google Authenticator dahulu',
    '请先添加收款方式': 'Sila tambah kaedah pembayaran dahulu',
    '请先通过高级认证': 'Sila lengkapkan pengesahan lanjutan dahulu',
    '请选择买卖方式': 'Sila pilih kaedah beli/jual',
    '请选择正确的币种': 'Sila pilih mata wang yang betul',
    '请重新登录': 'Sila log masuk semula',
    '渠道未开通': 'Saluran belum diaktifkan',
    '取消': 'Batal',
    '确认': 'Sahkan',
    '申购数量错误': 'Kuantiti langganan tidak sah',
    '申请成功': 'Permohonan berjaya',
    '身份证已实名过!': 'Kad pengenalan telah disahkan!',
    '审核已通过': 'Semakan diluluskan',
    '审核中': 'Dalam semakan',
    '实名认证未通过，无法进行高级认证': 'Pengesahan identiti tidak lulus, tidak boleh membuat pengesahan lanjutan',
    '收款方输入错误': 'Input penerima bayaran tidak sah',
    '授权状态未成功': 'Status kebenaran tidak berjaya',
    '赎回状态异常': 'Status penebusan tidak normal',
    '所选汇率不存在': 'Kadar pertukaran yang dipilih tidak wujud',
    '提币数量不能小于等于0': 'Kuantiti pengeluaran tidak boleh kurang atau sama dengan 0',
    '提交失败': 'Penghantaran gagal',
    '提交失败，当前有未处理订单': 'Penghantaran gagal, terdapat pesanan belum diproses',
    '提示': 'Pemberitahuan',
    '提现不得大于限额': 'Pengeluaran tidak boleh melebihi had',
    '提现不得小于限额': 'Pengeluaran tidak boleh kurang daripada had',
    '图片不得大于10M': 'Gambar tidak boleh melebihi 10MB',
    '图片不得大于2M': 'Gambar tidak boleh melebihi 2MB',
    '图片大小不能超过2M！': 'Saiz gambar tidak boleh melebihi 2MB!',
    '图片上传失败': 'Muat naik gambar gagal',
    '推荐码不正确': 'Kod rujukan tidak betul',
    '推荐人无权限推荐': 'Perujuk tiada kebenaran untuk merujuk',
    '推荐商品': 'Produk disyorkan',
    '委托数量(张)必填': 'Kuantiti pesanan (kontrak) wajib diisi',
    '委托数量(张)不能小于等于0': 'Kuantiti pesanan (kontrak) tidak boleh kurang atau sama dengan 0',
    '未绑定谷歌验证器': 'Google Authenticator belum dipaut',
    '未绑定手机号': 'Nombor telefon belum dipaut',
    '未绑定邮箱': 'E-mel belum dipaut',
    '未发现授权记录': 'Tiada rekod kebenaran ditemui',
    '未实名认证，是否认证？': 'Belum disahkan. Sahkan sekarang?',
    '未授权访问': 'Akses tanpa kebenaran',
    '未找到符合条件的匹配订单': 'Tiada pesanan sepadan ditemui',
    '未找到匹配的收益记录': 'Tiada rekod pendapatan sepadan ditemui',
    myComment: 'Ulasan saya',
    myPoint: 'Mata saya',
    accountInfo: 'Maklumat akaun',
    myBalance: 'Baki saya',
    myCoupon: 'Kupon saya',
    unused: 'Belum digunakan',
    used: 'Telah digunakan',
    expired: 'Tamat tempoh',
    expires: 'Sah hingga',
    minSpend: 'Minimum',
    availableBalance: 'Baki tersedia',
    personalDeposit: 'Deposit',
    useDepositBalance: 'Guna baki untuk potongan',
    depositDeduct: 'Potongan baki',
    useMaxDeposit: 'Potongan penuh',
    balanceHistory: 'Sejarah baki',
    recordCount: 'Jumlah {count} rekod',
    depositType: 'Jenis transaksi',
    balanceAfter: 'Baki akhir',
    depositTypeRecharge: 'Tambah nilai baki',
    depositTypeAdjustment: 'Pelarasan baki',
    depositTypeOrderPayment: 'Bayaran pesanan',
    depositTypeOrderRefunds: 'Bayaran balik pesanan',
    depositTypeDistributionCommission: 'Komisen pengedaran',
    depositTypeDistributionWithdrawal: 'Pengeluaran pengedaran',
    depositTypeOther: 'Lain-lain',
    income: 'Pendapatan',
    expense: 'Perbelanjaan',
    description: 'Penerangan',
    myFootprint: 'Jejak saya',
    '我的购物车': 'Troli saya',
    '无权限': 'Tiada kebenaran',
    '无效的UID': 'UID tidak sah',
    '系统参数错误': 'Ralat parameter sistem',
    '系统存在相同[系统登录名]！': 'Sistem mempunyai [nama log masuk] yang sama!',
    '系统错误，请稍后重试': 'Ralat sistem, sila cuba lagi kemudian',
    '下单不能小于最小金额限制': 'Pesanan tidak boleh kurang daripada jumlah minimum',
    '校验IP不合法': 'IP pengesahan tidak sah',
    '新密码不能为空': 'Kata laluan baharu tidak boleh kosong',
    '新密码不一致': 'Kata laluan baharu tidak sepadan',
    '新密码确认不能为空': 'Pengesahan kata laluan baharu tidak boleh kosong',
    '行情获取异常，稍后再试': 'Gagal mendapatkan data pasaran, sila cuba lagi kemudian',
    '验证类型不能为空': 'Jenis pengesahan tidak boleh kosong',
    '验证码不能为空': 'Kod pengesahan tidak boleh kosong',
    '验证码不正确': 'Kod pengesahan tidak betul',
    '验证码错误': 'Kod pengesahan salah',
    '页码不能小于等于0': 'Nombor halaman tidak boleh kurang atau sama dengan 0',
    '页码不是整数': 'Nombor halaman bukan integer',
    '已领取': 'Telah dituntut',
    '用户不存在': 'Pengguna tidak wujud',
    '用户名必须由数字和英文字母组成': 'Nama pengguna mesti terdiri daripada nombor dan huruf Latin',
    '用户名不存在': 'Nama pengguna tidak wujud',
    '用户名不符合设定': 'Nama pengguna tidak memenuhi keperluan',
    '用户名不能为空': 'Nama pengguna tidak boleh kosong',
    '用户名参数为空': 'Parameter nama pengguna kosong',
    '用户名重复': 'Nama pengguna berulang',
    '用户剩余数量不足': 'Baki kuantiti pengguna tidak mencukupi',
    '用户已跟随交易员': 'Pengguna telah mengikut pedagang',
    '邮箱已绑定': 'E-mel telah dipaut',
    '邮箱已绑定其他用户': 'E-mel telah dipaut dengan pengguna lain',
    '余额不足': 'Baki tidak mencukupi',
    shop_order_insufficientBalance: 'Baki akaun tidak mencukupi',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Akaun tidak normal memerlukan pengesahan C3. Sila hubungi khidmat pelanggan dalam talian.',
    '找不到用户': 'Pengguna tidak ditemui',
    flashSale: 'Jualan Kilat',
    groupBuy: 'Beli berkumpulan',
    groupBuying: 'Pembelian berkumpulan',
    couponCenter: 'Pusat kupon',
    pointMall: 'Pusat mata',
    liveList: 'Siaran langsung',
    endsIn: 'Berakhir dalam',
    soldOut: 'Terjual',
    people: 'orang',
    joined: 'Telah menyertai',
    startGroup: 'Mulakan kumpulan',
    getCoupon: 'Tuntut',
    '直线关系，不能修改推荐': 'Hubungan langsung, rujukan tidak boleh diubah',
    '重复提交': 'Penghantaran berulang',
    '转账币种不能为空': 'Mata wang pemindahan tidak boleh kosong',
    '转账数量不能小于等于0': 'Kuantiti pemindahan tidak boleh kurang atau sama dengan 0',
    '状态不能小于0': 'Status tidak boleh kurang daripada 0',
    '状态不是整数': 'Status bukan integer',
    '资金密码必须6-12位': 'Kata laluan dana mesti 6-12 aksara',
    '资金密码不符合设定': 'Kata laluan dana tidak memenuhi keperluan',
    '资金密码不能为空': 'Kata laluan dana tidak boleh kosong',
    '资金密码错误': 'Kata laluan dana salah',
    '资金密码长度不符合设定': 'Panjang kata laluan dana tidak memenuhi keperluan',
    'UID不能为空': 'UID tidak boleh kosong',
    required: 'Medan ini wajib diisi',
    nickname: 'Nama samaran',
    enterNickname: 'Sila masukkan nama samaran',
    gender: 'Jantina',
    male: 'Lelaki',
    female: 'Perempuan',
    secret: 'Sulit',
    birthday: 'Hari lahir',
    selectDate: 'Pilih tarikh',
  cancelOrderMap: {
    0: "Saya tidak mahu.",
    1: "Tersalah letak produk",
    2: "Pesanan pendua",
    3: "Terima gagal",
    4: "Sebab lain",
  },
  "电商批发商场": "Pasar borong e-dagang",
  "获取验证码": "Mendapatkan kod semula",
  "请输入验证码": "Sila masukkan kod semula",
  "验证码": "Kod semula",
  "发送": "Menghantar",
  "已发送，请注意查收":
    "Terkirim, perhatikan penghantaran",
  "当前余额": "Baki semasa",
  "请选择": "Sila pilih",
  "绑定成功": "Berjaya diikat",
  "仅能绑定一个收款地址!": "Hanya satu alamat penerimaan boleh diikat!",
  "提款地址绑定": "Alamat pengeluaran",
  "请输入完整的支付密码!" : "Sila masukkan kata laluan pembayaran yang lengkap!",
  "用户未发表评论": "Pengguna belum mengulas",
  "订单": "Pesanan",
  "备注": "Catatan",
  "下单成功，等待付款": "Pesanan berjaya dibuat, menunggu pembayaran",
  "下单成功，付款成功": "Pesanan berjaya dibuat, pembayaran berjaya",
  "已发货，正在运输中": "Dihantar, dalam pengangkutan",
  "订单已取消，原因:手动发起取消订单": "Pesanan telah dibatalkan. Sebab: Batalkan pesanan secara manual.",
  "订单已取消，原因:超时自动取消订单": "Pesanan telah dibatalkan. Sebab: Pesanan akan dibatalkan secara automatik apabila tamat masa.",
  "商家已确认，已进入备货状态": "Peniaga telah disahkan dan telah memasuki keadaan stok.",
  "系统发货成功": "Penghantaran sistem berjaya",
  "订单已签收": "Pesanan Diterima",
  "发起退款申请": "Mulakan permintaan bayaran balik",
  "退款成功": "Bayaran balik berjaya",
  "退款失败": "Bayaran balik gagal",
  "订单退款成功": "Bayaran balik pesanan berjaya",
  "订单退款失败": "Bayaran balik pesanan gagal",
  "系统默认好评": "Sistem lalai kepada ulasan yang menggalakkan",
  "请输入关键字搜索": "Sila masukkan kata kunci untuk mencari",
  "猜你喜欢": "Rasanya anda suka",
  "订单已完成": "Tempahan selesai",
  "热销推荐": "Cadangan Jualan Panas",
  "头像选择": "Pilihan Avatar",
  "修改头像": "Ubah suai avatar anda",
  subOrder: "Hantar pesanan",
  "mailboxCheck": "Sila isikan alamat e-mel yang betul",
  "switchLang": "Sila tukar kepada bahasa lain untuk melihat",
  "myCart": "Troli beli-belah saya",
  "notQua": "Syarat kelayakan tidak dipenuhi.",
  "noSmaller": "Amaun yang digunakan tidak boleh kurang daripada",
  "nomax": "Jumlah maksimum permohonan tidak boleh melebihi",
  "evaluationUploading": "Anda masih mempunyai gambar yang dimuat naik. Sila cuba sebentar lagi",
  "evaluateInput": "Semak dengan gambar",
  "moneyOrderStatus": "Status pesanan",
  "coinBlock": "Perjanjian mata wang",
  "dealing": "Dalam proses",
  "dealSuccess": "Berjaya",
  "dealFail": "gagal",
  "payCertificate": "Sijil pembayaran",
  "handleFee": "Caj perkhidmatan",
  "highOpinion": "Ulasan yang baik",
  "mediumOpinion": "Kajian sederhana",
  "lowOpinion": "Ulasan buruk",
  "hasImage": "Dengan gambar",
  "rechargeMethod": "Mod cas semula",
  "scanAndDown": "Imbas Kod QR Muat Turun APP",
  "receivedAddress": "Alamat resit",
  "ActualLedger": "Resit sebenar",
  "view": "Lihat",
  "withdrawNum": "Kuantiti pengeluaran tunai",
  "rechargeNum": "Kuantiti cas semula",
  "date": "Tarikh",
  "walletHistory": "Sejarah dompet",
  "accountBalance": "Baki akaun",
  "accountReview": "Gambaran keseluruhan akaun",
  "rated": "Disemak",
  "receiver": "Penerima",
  "orderStatus": "Status",
  "orderTime": "Masa",
  "tax": "percukaian",
  "discount": "Diskaun",
  "productInfo": "Informasi produk",
  "paramError": "Ralat parameter",
  "orderInfo": "Maklumat pesanan",
  "rebuy": "Satu pesanan lagi",
  "pleaseCorrectAddress": "Sila masukkan alamat pengeluaran tunai yang betul",
  "pleaseInputCorrectNumber": "Sila masukkan nombor yang lebih besar daripada 0",
  "vcodePass": "Pengesahan lulus!",
  "vcodeFail": "Pengesahan gagal, sila cuba lagi",
  "uploading": "Memuat naik...",
  "uploadSuccess": "Berjaya dimuat naik",
  "uploadError": "Muatnaik gagal. Sila cuba lagi",
  "registerSuccess": "Daftar berjaya",
  "pleaseSetMobileNumber": "Sila tetapkan nombor telefon",
  "unSelectedProduct": "Anda belum memilih produk",
  "loginSuccess": "Log masuk berjaya",
  "pleaseSetAreaCode": "Masukkan nama negara dan kod kawasan untuk mencari",
  "login": "Log masuk",
  "register": "Pendaftaran",
  "logout": "Keluar",
  "noData": "Tiada data dijumpai",
  "search": "Cari",
  "historySearch": "Pencarian sejarah",
  "empty": "kosong",
  "home": "Laman utama",
  "favorableRate": "Kadar ulasan yang baik",
  "classification": "kategori",
  "searchTips": "Carian sumber/produk/pembekal/pesanan",
  "dailyNewArrival": "Produk baharu harian disenaraikan",
  "more": "Lagi",
  "recommend": "Syor",
  "recommendedProducts": "Produk yang disyorkan",
  "recommendedStore": "Kedai yang disyorkan",
  "buyNow": "Beli sekarang",
  "addCart": "Tambahkan pada troli beli-belah",
  "complex": "Bersepadu",
  "price": "harga",
  "retailPrice": "Harga runcit",
  "originPrice": "Harga asal",
  "service": "Khidmat Pelanggan",
  "collect": "Kegemaran",
  "sold": "Jumlah Jualan",
  "pageviews": "Jumlah pelayaran",
  "quantity": "Kuantiti",
  "freight": "kargo",
  "shipping": "penghantaran",
  "ship": "bot",
  "buyTips": "Hantar dalam masa 24 jam selepas membuat pesanan. Pesanan berikut adalah di bawah kawalan logistik dan mungkin dihantar lewat. Sila beri perhatian kepada maklumat logistik atau hubungi perkhidmatan pelanggan.",
  "totalPrice": "Harga keseluruhan",
  "addCartMessage": "Berjaya ditambahkan pada troli beli-belah",
  "addCartMessageFaild": "Produk sudah wujud dalam troli beli-belah.",
  "myAccount": "akaun q saya",
  "buyHistory": "Rekod pembelian",
  "wishlist": "Produk kegemaran",
  "trackOrder": "Pesanan",
  "account": "Akaun:",
  "sellerZone": "Kawasan peniaga",
  "beSeller": "Menjadi seorang peniaga",
  "sellerPanelLogin": "Log masuk pedagang",
  "footTip": "© Hak Cipta {name} Ltd 2024",
  "footTips": "{name} Limited diberi kuasa dan dikawal oleh Pihak Berkuasa Kelakuan Kewangan sebagai broker kredit (713206) dan berurusan secara eksklusif dengan pemberi pinjaman Home Retail Group CardServices Limited sebagai {name} Financial Services. Perkhidmatan Kewangan {name} diberi kuasa dan dikawal oleh Pihak Berkuasa Kelakuan Kewangan untuk memberikan kredit (716148). Home Retail GroupCard Services Limited didaftarkan di United Kingdom (04007072) di Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Membuat pesanan",
  "productDescription": "Penerangan Produk",
  "userEvaluation": "Ulasan pengguna",
  "AllProducts": "Semua produk",
  "followers": "Ikut",
  "sales": "Jumlah Jualan",
  "visitStore": "Lawati kedai",
  "authentic": "100% tulen",
  "dayReturns7": "7 hari balik",
  "shippingDiscounts": "Diskaun pengangkutan",
  "safePayment": "Pembayaran Selamat",
  "followed": "Diikuti",
  "dashboard": "Panel Instrumen",
  "myOrder": "Arahan saya",
  "setUp": "Persediaan",
  "successTips": "Berjaya",
  "copySuccess": "Replikasi berjaya",
  "balance": "Baki(USDT)",
  "sort": "taip",
  "commodity": "produk",
  "browse": "Jumlah Jualan",
  "recharge": "Isi semula",
  "commodityCollection": "Koleksi produk",
  "withdraw": "Pengeluaran tunai",
  "defaultAddress": "Alamat lalai",
  "addNewAddress": "Tambah alamat baharu",
  "withdrawRecord": "Rekod pengeluaran tunai",
  "serialNumber": "Pesanan No.",
  "time": "Masa",
  "amount": "Jumlah",
  "processing": "Dalam proses",
  "fail": "gagal",
  "blockchainNetwork": "Rangkaian rantaian blok",
  "records": "Rekod",
  "withdrawAddress": "Alamat pengeluaran tunai",
  "withdrawInputTips": "Sila masukkan alamat pengeluaran",
  "copy": "Replikasi",
  "enterTips": "Sila masukkan",
  "actualAccount": "Akaun sebenar",
  "handlingFee": "Caj perkhidmatan",
  "confirm": "Sahkan resit",
  "previous": "Langkah sebelumnya",
  "pleaseEnterAddress": "Sila masukkan alamat",
  "pleaseEnterQuantity": "Sila masukkan kuantiti",
  "withdrawSuccess": "Pesanan berjaya dihantar",
  "saveQr": "Simpan kod QR",
  "pleaseEnterAmount": "Sila masukkan jumlah caj semula",
  "expectedArrival": "Ketibaan yang dijangkakan",
  "currentRate": "Kadar pertukaran semasa",
  "uploadTips": "Bukti pembayaran (Muat naik tangkapan skrin butiran pembayaran)",
  "clickUpload": "Klik untuk memuat naik",
  "uploadPhoto": "Sila muat naik foto",
  "rechargeSuccessful": "Caj semula berjaya",
  "rechargeTips": "\"Gesaan pengecasan semula: \"\"Sila isikan jumlah pemindahan sebenar dengan jujur. Jika tidak, sistem mungkin gagal lulus kelulusan dan menjejaskan kemajuan pengecasan semula.\"",
  "rechargeRecord": "Rekod cas semula",
  "all": "Semua",
  "pending": "Untuk dibayar",
  "cancelled": "Dibatalkan",
  "delivered": "Untuk dihantar",
  "confirmed": "Disahkan",
  "receipt": "Untuk diterima",
  "harvested": "Menerima",
  "comment": "Untuk disemak",
  "refund": "Bayaran balik/selepas jualan",
  "cancelOrder": "Batalkan pesanan",
  "cancelReason": "Sebab pembatalan",
  "cancelOrderTitle": "Sila pilih sebab pembatalan pesanan",
  "returnOrderTitle": "Sila pilih sebab pulangan",
  "refundInstructions": "Arahan bayaran balik",
  "returnDetailTips": "Sila beri ulasan tentang produk",
  "cancel": "Batalkan pesanan",
  "cancelOrder1": "Produk tidak diterima",
  "cancelOrder2": "Tidak suka, tidak mahu",
  "cancelOrder3": "Penjual tersalah hantar barang",
  "cancelOrder4": "Jenama palsu",
  "cancelOrder5": "Kurang penghantaran, terlepas penghantaran",
  "cancelOrder6": "Produk diterima rosak",
  "cancelOrder7": "Ada masalah kualiti",
  "cancelOrder8": "Rundingkan bayaran balik dengan peniaga",
  "cancelOrder9": "Sebab lain",
  "cancelOrderSuccess": "Pesanan berjaya dibatalkan",
  "returnOrderSuccess": "Hantar berjaya",
  "orderName": "Nama",
  "orderEmail": "E-mel",
  "orderAddress": "Alamat",
  "orderNation": "Negara",
  "orderState": "Status",
  "orderCity": "Bandar",
  "orderPostCode": "Poskod",
  "orderAmount": "Kuantiti",
  "orderPrefix": "Jumlah pesanan",
  "orderFee": "Cukai",
  "orderSpecification": "Spesifikasi",
  "orderCommodity": "produk",
  "orderQuantity": "Kuantiti",
  "orderUnitprice": "Harga seunit",
  "orderFreight": "kargo",
  "orderTax": "Cukai",
  "orderTotal": "Jumlah",
  "PaymentOrder": "Pesanan pembayaran",
  "Evaluate": "Semakan",
  "CancelOrder": "Batalkan pesanan",
  "RemindShip": "Ingatkan untuk Penghantaran",
  "Refund": "Bayaran balik",
  "Submitareview": "Hantar ulasan",
  "Information": "Maklumat",
  "wrongPassword": "Ralat kata laluan lebih daripada 3 kali. Sila cuba lagi esok.",
  "Operate": "Operasi",
  "Item": "Item (s)",
  "From": "daripada",
  "hint": "Petua",
  "CheckDetails": "Lihat butiran",
  "Payment": "Bayaran",
  "Cancel": "Batal",
  "refundSuccessfully": "Bayaran balik berjaya",
  "pendingPayment": "Untuk dibayar",
  "pay": "Bayaran",
  "LoginPassword": "Kata laluan log masuk",
  "sure": "Sudah tentu",
  "shippingAddress": "Menerima alamat",
  "transactionPassword": "Kata laluan transaksi",
  "markDefaultAddress": "Tandai sebagai alamat penghantaran lalai",
  "edit": "Diedit oleh",
  "delete": "Padam",
  "Opt": "Pilih",
  "piece": "Pcs",
  "orderDetails": "Maklumat pesanan",
  "shopCollection": "Tambahkan kedai ke kegemaran",
  "addAddress": "Tambah alamat baharu",
  "signUp": "Pendaftaran",
  "loginTips": "Sudah mempunyai akaun?",
  "loginIn": "Log masuk",
  "mobile": "No telefon",
  '购物车还没有商品': "Troli beli-belah anda kosong",
  '去购物': "Mulakan membeli-belah",
  "modifyAddress": "Ubah suai alamat",
  "desc": "Tetapkan sebagai alamat lalai",
  "keep": "Kekalkan",
  "onlineService": "Perkhidmatan dalam talian",
  "send": "Hantar",
  "EsShop": "Kedai atas talian",
  "desc3": "Masukkan kata laluan transaksi",
  "desc4": "Masukkan kata laluan transaksi anda",
  "desc6": "Masukkan kata laluan transaksi anda sekali lagi",
  "setUpPayPaw": "Tetapkan kata laluan transaksi",
  "setSuccess": "Persediaan berjaya",
  "confirmPayPaw": "Sahkan kata laluan transaksi",
  "paymentSuccessful": "Pembayaran berjaya",
  "desc5": "Alamat penghantaran salah? Kenalan",
  "customeService": "Perkhidmatan pelanggan dalam talian",
  "BackHome": "Kembali ke halaman utama",
  "Checkorder": "Lihat Pesanan",
  "ForgotPassword": "Lupa kata laluan?",
  "signIn": "Log masuk",
  "noAccount": "Tiada nombor akaun?",
  "pleaseEnterAccount": "Sila masukkan nombor akaun",
  "pleaseEnterPassword": "Sila masukkan kata laluan",
  "password": "Kata laluan",
  "mobilePhone": "Nombor telefon",
  "pleaseEnterPhoneNumer": "Sila tetapkan nombor telefon",
  "setPassword": "Tetapkan kata laluan",
  "noDataFound": "Tiada data dijumpai",
  "searchCountry": "Masukkan nama negara dan kod kawasan untuk mencari",
  "pleaseEnterEmail": "Sila tetapkan peti mel",
  "invitationCode": "Kod Jemputan",
  "plaeseEnterInvitaionCode": "Sila tetapkan kod jemputan",
  "pleaseSetLoginPassword": "Sila tetapkan kata laluan log masuk",
  "selectDeliveryAddress": "Pilih alamat penghantaran",
  "totalOf": "Jumlah",
  "items": "item",
  "orderSummary": "Ringkasan pesanan",
  "paymentMethod": "Kaedah pembayaran",
  "Balance": "Seimbang",
  "payPal": "PayPal",
  "notOpen": "Kaedah pembayaran ini belum dibuka untuk wilayah anda",
  "mastercard": "MasterCard",
  "additional": "Tambahan",
  "handlingfee": "Caj perkhidmatan diperlukan",
  "goodsNumber": "Kuantiti produk",
  "deliveryFee": "Pengangkutan",
  "totalNum": "Jumlah",
  "new": "Baru",
  "oldPassword": "Kata laluan lama",
  "pleaseEnterOldPassword": "Sila masukkan kata laluan lama",
  "newPassword": "Kata laluan baharu",
  "plaseeEnterNewPassword": "Sila masukkan kata laluan baharu",
  "confirmPassword": "Sahkan kata laluan",
  "plaseeENterConfirmPassword": "Sila masukkan kata laluan pengesahan",
  "twoPawword": "Dua kata laluan tidak sama",
  "rechargeAddress": "Alamat cas semula",
  "plaseEnterRechargeAddress": "Sila masukkan alamat cas semula",
  "userCenter": "Pusat peribadi",
  "merchantSettled": "Kemasukan peniaga",
  "upNew": "Produk baru disenaraikan",
  "balanceNot": "Baki tidak mencukupi. Tolong cas semula.",
  "NoProductSelected": "Produk belum dipilih lagi",
  "ShippingAddressNotSet": "Alamat penghantaran tidak ditetapkan",
  "consigneeName": "Nama penerima",
  "email": "E-mel:",
  "areaCode": "Kod kawasan antarabangsa",
  "phoneNumber": "Nombor telefon",
  "nation": "Negara",
  "state": "Wilayah/Negeri/Negeri",
  "city": "Bandar",
  "postCode": "Poskod",
  "address": "Alamat terperinci",
  "addAddressOrModifyAddress": "Tambah alamat baharu/Ubah suai alamat",
  "setAsTheDefaultAddress": "Tetapkan sebagai alamat lalai",
  "proceed": "teruskan",
  "btnSure": "sahkan",
  "pleaseInput": "Sila masukkan",
  "allProduct": "Semua produk",
  "myCommodityCollection": "Produk kegemaran",
  "myFollowedShops": "Ikut kedai",
  "mySold": "terjual",
  "myPageviews": "Jumlah pelayaran",
  "myPraiseRate": "Kadar ulasan yang baik",
  "myUnfollow": "nyahikut",
  "inputNum": "Nombor",
  "inpuEmailErro": "Sila masukkan alamat e-mel yang betul",
  "goodsShip": "Penghantaran",
  "goodsShipTips": "Produk akan dihantar dalam masa 24 jam selepas membuat pesanan. Jika kawalan logistik wujud untuk pesanan berikut, pesanan mungkin ditangguhkan. Sila beri perhatian kepada maklumat logistik pesanan atau hubungi perkhidmatan pelanggan.",
  "goodsFreight": "Pengangkutan",
  "goodsFreeShipping": "Percuma",
  "goodsFreightTips1": "1. Komposisi pengangkutan produk merentas sempadan: tambang=yuran penghantaran+ tambang jarak jauh+ yuran penghantaran",
  "goodsFreightTips2": "2. Jika syarat pos tidak dipenuhi, tambang hendaklah dicaj mengikut syarat sebenar.",
  "goodsFreightTips3": "3. Hak tafsiran akhir adalah milik platform.",
  "pleaseValidPostCode": "Sila masukkan lebih daripada 4 digit",
  "pleaseValidEmail": "Sila masukkan alamat e-mel yang betul",
  "pleaseValidPhone": "Sila masukkan nombor telefon yang betul",
  "productAvailable": "Produk ini telah dikeluarkan",
  "validatorMaxNumber": "Jumlah melebihi had",
  "validatorRequire": "Item yang diperlukan tidak boleh batal",
  "validatorPhone": "Sila masukkan nombor telefon yang betul",
  "validatorEmail": "Sila masukkan format e-mel yang betul",
  "validatorPassword": "Kata laluan terdiri daripada 6-12 digit atau huruf(mengandungi watak istimewa)",
  "validatorSixNumber": "Sila masukkan 6 digit tulen",
  "validatorFourMoreNumber": "Sila masukkan gabungan 4-32 digit atau huruf",
  recommendclass:"Mengesyorkan Kategori",
  "加值": "Nilai tambah",
  "提领": "Pengeluaran",
  "平台人工发起退款": "Platform memulakan pemulangan wang secara manual",
  "银行卡": "Kad bank",
  "联系商家": "Hubungi peniaga",
  "滑动验证":"Sila geser untuk mengesahkan",
  "validatorIpRule": "Format IP yang salah",
  "validatorChineseAndEnglish": "Bahasa Cina dan Inggeris sahaja, masukkan julat: 8-64 aksara",
  "collectionSuccess": "Tambah ke kegemaran berjaya",
  "followedSuccess": "Ikuti berjaya",
  "cancelSuccess": "Dibatalkan berjaya",
  "evaluateOrder": "Semak dengan gambar",
  "evaluateOrderPlaceholder": "Sila semak produk",
  "operationSuccess": "Operasi berjaya",
  "confirmReceiveGoods": "Sahkan penerimaan produk atau tidak",
  "evaluateOrderSuccess": "Semakan berjaya",
  "yesterday": "Semalam",
  "notLogin": "Anda belum log masuk lagi.",
  "delAllHistoryRecord": "Adakah anda pasti mahu memadamkan semua rekod sejarah?",
  "or": "Ataupun",
  "tipsRemindsText": "Peniaga akan menerima peringatan selepas penghantaran diingatkan",
  "tipsRemindsCount": "Ia hanya boleh diingatkan sekali sahaja.",
  "tipsRemindsMerchant": "Ingatkan peniaga",
  "tipsRemindsSuccess": "Peringatan berjaya",
  "noCartTips": "Beg beli-belah anda kosong. Mulakan membeli-belah.",
  "defaultRate": "Sistem lalai kepada ulasan yang menggalakkan",
  "prevPage": "Halaman sebelumnya",
  "nextPage": "Muka surat seterusnya",
  "returnApply": "Permintaan bayaran balik",
  "returnReason": "Sebab bayaran balik",
  "returnAmount": "Jumlah pulangan",
  "returnRemark": "Arahan pulangkan",
  order: {
    confirm: "Sahkan resit",
    cancel: "Batalkan pesanan",
    payment: "Bayar sekarang",
    remind: "Ingatkan untuk Penghantaran",
    return: "Minta bayaran balik produk",
    evaluate: "Semak sekarang",
    logistics: "Lihat logistik",
    noRefund: "Tidak dibayar balik",
    refunding: "Bayaran balik sedang dijalankan",
    refundSuccess: "Bayaran balik berjaya",
    refundFail: "Bayaran balik gagal",
        expressCompany: 'Kurier',
        trackingNo: 'Nombor penjejakan',
        noOrderShipping: 'Tiada maklumat penghantaran',
        noTransitSteps: 'Tiada kemas kini penjejakan',
        logisticsLoadFail: 'Gagal memuatkan logistik. Sila cuba lagi kemudian.'
  },
  "remindTitle": "Ingatkan untuk Penghantaran",
  "remindContent": "Selepas penghantaran diingatkan, peniaga akan menerima peringatan tersebut. Ia hanya boleh diingatkan sekali sahaja.",
  "remindSuccess": "Peringatan berjaya",
  "remindRepeat": "Perintah ini telah diingatkan.",
  "noComments": "Tiada ulasan pada masa ini",
  "storeSeach": "Cari produk di kedai ini",
  "storeSeachTips1": "Ditemui untuk anda",
  "storeSeachTips2": "Kedai berkaitan ditemui",
  "storeSeachTips3": "Rumah",
  "creditTit": "Perkhidmatan kredit",
  "getCoupons": "Dapatkan lebih banyak kupon",
  "yourEmail": "alamat e-mel anda",
  "subscription": "Langganan",
  "paymethods": "Kaedah pembayaran",
  "footdec": "Pengguna tapak global {name} berasal dari {num} negara di seluruh dunia dan menggunakan {coin} untuk penyelesaian. {coin} ialah transaksi tanpa sempadan yang membolehkan transaksi kos rendah segera di seluruh dunia tanpa menunggu dan yuran antarabangsa.",
  "custService": "Khidmat Pelanggan",
  "helpLine": "Perkhidmatan pelanggan dalam talian",
  "contactUs": "Hubungi Kami",
  "partner": "Pembekal koperasi",
  "客户端下载": "Pelanggan untuk mengunduh",
  "提现方式": "Kaedah pengeluaran",
  "buyRules": "Peraturan pembeli",
  "sellerRules": "Dasar penjual",
  "returnsAndEx": "Pemulangan dan Pertukaran",
  "servicePolicy": "Dasar perkhidmatan",
  "returnPolicy": "Syarat pengembalian",
  "user_Center": "Pusat pengguna",
  "userReg": "Pendaftaran pengguna",
  "orderTrack": "Pertanyaan pesanan",
  "purchageHistory": "Sejarah pembelian",
  "myPurse": "Dompet saya",
  "aboutUs": "Tentang kita",
  "Recruitment": "Tunggu orang yang berbakat",
  "news": "Maklumat berita",
  "stateMent": "Kenyataan perhambaan moden",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "MetaMask",
  "homeBannertips1": "Menjadi seorang peniaga",
  "homeBannertips2": "Jumlah komisen",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Sertai sekarang",
  "homeDownloadtips1": "Pusat beli-belah borong e-dagang merentas sempadan",
  "homeDownloadtips2": "Tawaran istimewa jenama",
  "homeDownloadtips3": "Diskaun tanpa henti",
  "homeDownloadtips4": "muat turun Android",
  "homeDownloadtips5": "Muat turun Apple",
  "homeDownloadtips6": "Imbas kod QR untuk memuat turun APP",
  "homeIconTips1": "100% tulen",
  "homeIconTips2": "7 hari balik",
  "homeIconTips3": "Diskaun pengangkutan",
  "homeIconTips4": "Pembayaran selamat",
  "headerSearchTips": "Sila masukkan kata kunci untuk mencari",
  "collAccount": "Cara pinjaman",
  "mine": "saya.",
  "creditText1": "Pinjaman permulaan menyelesaikan masalah meminjam wang",
  "creditText2": "Menyediakan perkhidmatan pinjaman permulaan dan pusing ganti modal",
  "creditWorry": "Pinjaman tanpa kebimbangan",
  "creditQuota": "Had fleksibel",
  "creditQuotaINFO": "100,000 hingga 30,000,000 dengan had fleksibel dan tiada sekatan, dengan tempoh pinjaman maksimum setahun.",
  "quickLoan": "Pinjaman cepat",
  "creditReview": "Lulus audit dalam masa sejam paling awal, jika semakan lulus, pinjaman akan dikeluarkan dengan segera.",
  "safe": "Selamat dan tidak bimbang",
  "safeInfo": "Tiada gadai janji, tiada deposit, tiada panggilan balik, kerana ini sebenarnya adalah urusan peribadi.",
  "about": "Tentang kita",
  "aboutText1": "\"Kami komited untuk meminjamkan perkhidmatan kewangan, berdasarkan falsafah perniagaan \"\"diutamakan pelanggan\"\", memegang misi menyelesaikan masalah pusing ganti modal pelanggan. Sejak penubuhannya, syarikat telah membantu ramai pelanggan untuk menyelesaikan masalah pusing ganti modal.\"",
  "aboutText2": "Had: 100,000-30,000,000, kaedah pembayaran balik yang fleksibel dengan faedah rendah, tiada yuran pendahuluan, pinjaman dalam talian, tiada panggilan telefon untuk pengesahan, maklumat sulit dan pinjaman hari yang sama.",
  "contactUs1": "Jika anda tidak mahu meminjam wang daripada rakan setingkat anda, sila hubungi kami.",
  "committed": "Komited dengan perkhidmatan pinjaman usahawan",
  "financial": "Atasi masalah kewangan anda",
  "partnersTit": "Platform Pinjaman Dalam Talian Rakan Kongsi",
  "application": "Permohonan pinjaman",
  "applicant": "Pemohon",
  "actualName": "Nama sebenar",
  "yourName": "Sila masukkan nama",
  "term": "Tempoh pinjaman",
  "applicationAmount": "Jumlah yang diminta",
  "rates": "Kadar faedah pinjaman",
  "loanMethod": "Cara pinjaman",
  "accountB": "Baki akaun",
  "countryOf": "kewarganegaraan",
  "myloan": "pinjaman saya",
  "applyLoan": "Mohon pinjaman",
  "loaned": "Dipinjamkan",
  "interest": "Faedah terakru",
  "esRepayment": "Anggaran bayaran balik",
  "loanHistory": "Rekod pinjaman",
  "applicantDate": "Tarikh permohonan",
  "repayment": "Bayaran balik",
  "cycle": "Kitaran pembayaran balik",
  "fixedRate": "Kadar faedah tetap",
  "successLoan": "Pinjaman berjaya",
  "Reapply": "Mohon semula",
  "borrow": "Pinjaman gagal",
  "applicantIn": "Permohonan sedang dijalankan",
  "repaid": "Bayaran balik",
  "overdue": "Tertunggak",
  "estirepay": "Anggaran bayaran balik",
  "loanDays": "Bilangan hari dipinjamkan",
  "reAmount": "Jumlah bayaran balik",
  "repay": "Mod pembayaran balik",
  "entRepay": "Sahkan pembayaran balik",
  "foryourmoney": "Sekiranya anda kekurangan dana, tidak mencari tempat untuk meminjam wang atau malu untuk meminjam wang daripada rakan anda, anda boleh menghubungi kami. Kami mempunyai keseluruhan proses perkhidmatan profesional untuk menjawab keraguan anda pada bila-bila masa. Matlamat kami adalah untuk menjadikan setiap pinjaman telus, supaya pelanggan boleh menggunakannya dengan cepat dan yakin.",
  "onlineApplin": "Mohon dalam talian",
  "businessloan": "Permohonan untuk pinjaman permulaan",
  "selectCountry": "Sila pilih kewarganegaraan",
  "selectPeriod": "Sila pilih tempoh",
  "passPortImg": "No. ID/No. Pasport",
  "uploadId": "Muat naik gambar sijil/pasport",
  "readAndAgree": "Saya telah membaca dan bersetuju",
  "loanAgree": "Perjanjian pinjaman",
  "submitApplica": "Penyerahan permohonan",
  "photoExample": "Contoh mengambil gambar",
  "discounted": "Produk diskaun",
  "days": "hari",
  "privacyPolicy": "Dasar privasi",
  "delivery": "Penghantaran dan pengambilan",
  "checkAgreement": "Sila tandakan perjanjian!",
  "businessPhone": "Telefon bisnes",
  "businessEmail": "E-mel Korporat",
  "最多上传9张图片": "Maksimum 9 gambar",
  "账号注销": "Log keluar",
  "确定注销": "Log keluar",
  "您的账号": "Akaun anda",
  "企业电话": "Telefon bisnes",
  "职业机会": "Kemungutan pekerjaan",
  "最多包含10位小数": "Maksimum 10 titik perpuluhan",
  "为什么要离开": "Kenapa anda perlu meninggalkan?",
  "您还有余额,不能注销账号": "Anda masih mempunyai baki, tidak boleh log keluar!",
  "长时间未付款，系统自动取消订单": "Pesanan dibatalkan secara automatik kerana tidak dibayar dalam masa yang lama",
  "请输入注销理由": "Sila masukkan sebab log keluar",
  "您确认要注销吗?": "Anda pasti ingin log keluar?",
  "我再考虑下": "Batal",
  "同意注销": "Log keluar",
  "注销成功": "Log keluar berjaya",
  "暂无店铺": "Tiada kedai",
  "App下载(买家端)": "Muat turun aplikasi (pelanggan)",
  "App下载(卖家端)": "Muat turun aplikasi (penjual)",
  "加密货币": "Mata wang digital",
  '参数缺失': "Parameter yang hilang",
  '充值数量必填': "Jumlah topup diperlukan",
  "银行卡": "Kad bank",
  "充值币种": "Mata wang topup",
  "充值金额": "Jumlah topup",
  "充值金额不得小于": "Jumlah topup tidak boleh kurang daripada",
  "充值金额不得大于": "Jumlah topup tidak boleh melebihi",
  "请先选择币种": "Sila pilih mata wang terlebih dahulu",
  "开户行": "Nama bank",
  "请输入开户行名称": "Sila masukkan nama bank",
  "银行卡号": "Nombor kad bank",
  "请输入银行卡号": "Sila masukkan nombor kad bank",
  "点击去支付": "Klik untuk membayar",
  "企业证明": "Sijil syarikat",
  footTipTikTok:'BizSpring ©️2024 Hak Cipta',
  TikTokFoot:'BizSpring ialah platform sosial video pendek global BizSpring dan syarikat perdagangan borong terbesar di Asia Alibaba, ditubuhkan dengan kerjasama. Ia ialah platform e-dagang global dan mempunyai tiga gudang pintar yang dikendalikan sendiri di dunia, terletak di Toronto, Kanada, Los Angeles dan Chiba, Jepun. Produk yang dijual dalam apl termasuk produk popular dari Jepun, Korea Selatan, China dan negara Asia yang lain. Pada masa ini, jumlahnya telah melebihi 50,000 dan terus berkembang pesat.',
  "cancelInfo":"amaran! Sila berhati-hati untuk membatalkan akaun. Jika anda tidak lagi menggunakan akaun, anda boleh mengklik [Setuju untuk Pembatalan]. Anda mungkin tidak dapat mendaftar dalam masa beberapa hari selepas pembatalan."
,
  "getCouponSuccess": "Berjaya diterima",
  "liveRooms": "Bilik Langsung",
  "liveStreaming": "Langsung",
  "notStarted": "Belum Bermula",
  "finished": "Tamat",
  "myPoints": "Mata Saya",
  "searchGoods": "Cari Produk",
  "points": "Mata",
  "point": "Mata",
  "stock": "Stok",
  "spec": "Spesifikasi",
  "exchangeNow": "Tukar Sekarang",
  "currentPoint": "Mata Saya",
  "pointNotEnough": "Mata tidak mencukupi"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "马来语(ms)",
    "addImageHint": "(Sila tambah imej)",
    "deleteNode": "Padam",
    "topPos": "Atas {n}",
    "col": "Lajur {n}",
    "pos": "Kedudukan {n}",
    "decoType_container": "Bekas",
    "decoType_title": "Teks tajuk",
    "decoType_richText": "Teks kaya",
    "decoType_notice": "Notis",
    "decoType_blank": "Pemisah",
    "decoType_banner": "Karusel",
    "decoType_imageSingle": "Imej tunggal",
    "decoType_imageMulti": "Berbilang imej",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Produk disyorkan",
    "decoType_goodsSelection": "Pilihan produk",
    "decoType_seckill": "Jualan kilat",
    "decoType_groupBuy": "Beli berkumpulan",
    "decoType_coupon": "Kupon",
    "decoType_searchNav": "Navigasi carian",
    "decoType_search": "Kotak carian",
    "decoType_searchBox": "Kotak carian",
    "decoType_categoryNav": "Navigasi kategori",
    "decoType_goodsCategory": "Kategori produk",
    "decoType_navIconRow": "Ikon navigasi",
    "decoType_imageScroll": "Tatal imej",
    "decoType_pageBanner": "Sepanduk halaman",
    "decoType_tabs": "Tab",
    "decoType_brand": "Jenama",
    "decoType_storeRecommend": "Kedai disyorkan",
    "decoType_hotSelection": "Pilihan popular",
    "decoType_footerLinkGroup": "Pautan footer",
    "decoType_partnerLogoRow": "Rakan kongsi",
    "decoType_icpInfo": "Maklumat ICP",
    "decoType_topNavMenu": "Navigasi atas",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Bahasa",
    "decoType_currencySwitcher": "Mata wang",
    "decoType_loginBlock": "Log masuk",
    "decoType_cartIcon": "Troli",
    "decoType_messageIcon": "Mesej",
    "seckillPrice": "Harga kilat",
    "seckillTag": "Jualan kilat",
    "seckillCountdown": "Tamat dalam",
    "seckillNotStarted": "Tidak lama lagi",
    "seckillRushing": "Sedang berlangsung",
    "seckillWillStart": "Tidak lama lagi",
    "seckillBuy": "Beli sekarang (kilat)",
    "groupPrice": "Harga kumpulan",
    "groupRequiredNum": "orang untuk kumpulan",
    "noGroupBuy": "Beli sendiri",
    "groupRule1": "1. Pilih produk",
    "groupRule2": "2. Mula kumpulan",
    "groupRule3": "3. Kumpulan lengkap → penghantaran",
    "marketingMoneyOff": "Potongan",
    "marketingFreeShipping": "Penghantaran percuma",
    "marketingGift": "Hadiah",
    "marketingCoupon": "Kupon",
    "marketingGroup": "Beli berkumpulan",
    "marketingSeckill": "Jualan kilat",
    "marketingExpired": "Promosi tamat",
    "marketingNotActive": "Promosi tidak aktif",
    "alreadyGotCoupon": "Diterima",
    "couponReceived": "Diterima",
    "hotSearch": "Carian popular:"
}